// extracted by mini-css-extract-plugin
export default {"container":"loadmap_container__OIvAy","content":"loadmap_content__AAnsZ","footer":"loadmap_footer__miS9v","title":"loadmap_title__lLhmU"};